import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { capturePendingReferralFromUrl } from "./referral/pending-referral";
import { consumeBrandRegistrationCallback } from "./auth/supabase";
import {
  initializeDashboardAfterBrandCallback,
  removeBrandCallbackStartupShell,
} from "./startup";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Dashboard root is unavailable.");
}

void initializeDashboardAfterBrandCallback(
  () => consumeBrandRegistrationCallback(import.meta.env),
  () => capturePendingReferralFromUrl(window),
  async () => {
    const { App } = await import("./app");
    removeBrandCallbackStartupShell(document);
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  },
);
